export default __webpack_public_path__ + "static/media/blueCircleTick.d24877fd.svg";